<template>
  <span class="form-inline ml-1">
    <b-form-select
      class="float-right"
      v-if="this.connected"
      :size="size"
      v-model="modelScale"
      @change="updateSelectedScale($event)"
      :options="optionScales"
    >
    </b-form-select>
    <b-button href="#" v-if="!connected" variant="success" :size="size" class="float-left" @click="socketConnect()"
      >Pesa Off
    </b-button>
    <b-button
      href="#"
      v-if="connected"
      :pressed="true"
      variant="success"
      class="ml-1"
      :size="size"
      @click.prevent="socketDisconnect()"
      >Pesa On </b-button
    >&nbsp;&nbsp;&nbsp;
  </span>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "selectScale",
  props: {
    size: {
      type: String,
      default: "sm"
    }
  },
  data() {
    return {
      modelScale: null,
      optionScales: [{ value: null, text: "Seleccione romana" }]
    };
  },
  computed: {
    ...mapState("socketModule", ["socketWeight", "connected"])
  },
  methods: {
    ...mapActions("socketModule", ["socketDisconnect", "socketConnect"]),
    updateSelectedScale(val) {
      this.$store.dispatch("socketModule/updateSelectedScale", val);
    }
  },
  mounted() {
    this.$axios
      .get("/api/scale/electronicscale/scale_detail/", {
        params: {
          location_id: 1
        }
      })
      .then((res) => {
        var pesas = res.data.data;
        for (let i in pesas) {
          this.optionScales.push({ value: pesas[i].number, text: pesas[i].name });
        }
      })
      .catch(function (error) {
        console.log(error.response);
      });
  }
};
</script>

<style scoped></style>
